const firebaseConfig = {
    apiKey: "AIzaSyB0nvFvAowUD0M7om_Cr1Xt-n1olUQx6wg",
    authDomain: "medical-operation.firebaseapp.com",
    projectId: "medical-operation",
    storageBucket: "medical-operation.appspot.com",
    messagingSenderId: "203382692568",
    appId: "1:203382692568:web:29594dbd117b1b84b595ad"
};

export default firebaseConfig;